"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var React = require('react');

var PropTypes = require('prop-types');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var _Symbol = require('../symbol');

var BUTTON_SKINS = {
  LIGHT: 'light',
  LIGHT_DARK: 'light-dark',
  STANDARD: 'standard',
  PREMIUM: 'premium'
};
var BUTTON_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium'
};
var BUTTON_PRIORITIES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  INVERTED: 'inverted'
};

var IconButton = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(IconButton, _React$PureComponent);

  var _super = _createSuper(IconButton);

  function IconButton() {
    _classCallCheck(this, IconButton);

    return _super.apply(this, arguments);
  }

  _createClass(IconButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dataHook = _this$props.dataHook,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          skin = _this$props.skin,
          automationId = _this$props.automationId,
          children = _this$props.children,
          size = _this$props.size,
          priority = _this$props.priority,
          getClassName = _this$props.getClassName;
      var finalSkin = "".concat(skin.toLowerCase(), "-").concat(priority.toLowerCase());
      var finalSize = size === BUTTON_SIZES.MEDIUM ? 'icon-btn-size-medium' : '';
      return /*#__PURE__*/React.createElement("button", {
        className: getClassName("control-icon-button ".concat(finalSkin, " ").concat(finalSize)),
        "data-aid": automationId,
        "data-hook": dataHook,
        disabled: disabled,
        onClick: onClick
      }, /*#__PURE__*/React.createElement(_Symbol, null, children));
    }
  }]);

  return IconButton;
}(React.PureComponent);

IconButton.displayName = displayNames.ICON_BUTTON;
IconButton.propTypes = {
  /** make the component to be disabled and stop click events */
  disabled: PropTypes.bool,

  /** Hook for testing purposes  */
  dataHook: PropTypes.string,

  /** id for automation purposes  */
  automationId: PropTypes.string,

  /** triggered when button is clicked */
  onClick: PropTypes.func,

  /** Class Name **/
  className: PropTypes.string,

  /** changing the look of the component  */
  skin: PropTypes.oneOf(Object.values(BUTTON_SKINS)),

  /** changing the size of the component  */
  size: PropTypes.oneOf(Object.values(BUTTON_SIZES)),

  /** changing the priority of the component  */
  priority: PropTypes.oneOf(Object.values(BUTTON_PRIORITIES))
};
IconButton.defaultProps = {
  skin: BUTTON_SKINS.STANDARD,
  priority: BUTTON_PRIORITIES.PRIMARY,
  size: 'small'
};
module.exports = compose(IconButton);